module.exports = __webpack_public_path__ + "static/media/niceBees.c94fa5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/niceBees.jpg
// module id = 141
// module chunks = 0